import { useState, useEffect } from "react";
import side_img from "../../assets/pic/login_signup_img_.png";
import { toast } from "react-toastify";
import Spinner from "../../components/Spinner";
import { Link } from "react-router-dom";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import ForgotPasswordOTP from "../../components/ForgotPasswordOTP";
import api from "../../utils/api"; // Import the API utility
import log from "../../utils/logger"; // Import the logger

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loader, setLoader] = useState(false);
  const [OTPModal, setOTPModal] = useState(false);

  const handleOpenOTPModal = () => {
    setOTPModal(true);
  };

  const handleCloseOTPModal = () => {
    setOTPModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);

    try {
      const res = await api.post("/auth/forget-password", { email, role: "admin" });
      const data = res.data;

      setLoader(false);

      if (data.code === 200 && data.message === "Verify OTP") {
        toast.info("OTP has been sent to your email ID");
        handleOpenOTPModal();
      } else {
        toast.error(data.message || "An error occurred. Please try again.");
        log.warn(`Forgot password failed: ${data.message}`);
      }
    } catch (error) {
      setLoader(false);
      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data.message || "Invalid email address.";
        toast.error(errorMessage);
        log.error(`Forgot password error: ${error.message}, Response: ${errorMessage}`);
      } else {
        const errorMessage = "An error occurred. Please try again.";
        toast.error(errorMessage);
        log.error(`Forgot password error: ${error.message}, Response: ${errorMessage}`);
      }
    }
  };

  useEffect(() => {
    // Prevent scrolling of body content when the modal is open
    document.body.style.overflow = OTPModal ? "hidden" : "auto";
  }, [OTPModal]);

  return (
    <section className="flex xl:flex-row flex-col h-screen">
      <div className="hidden xl:flex items-center justify-center w-full xl:w-1/2 bg-gray-50">
        <img src={side_img} alt="login_signup_side_bg" className="h-auto" />
      </div>
      {OTPModal && (
        <ForgotPasswordOTP handleCloseOTPModal={handleCloseOTPModal} email={email} />
      )}
      <div className="flex flex-col items-center justify-center w-full xl:w-1/2 p-8">
        <div className="w-full max-w-md space-y-8">
          <div className="text-center">
            <h1 className="text-3xl font-bold text-gray-900">Forgot Password?</h1>
            <p className="text-sm text-gray-600 mt-2">
              Enter registered email ID to reset your password
            </p>
          </div>
          <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="rounded-md shadow-sm -space-y-px">
              <div>
                <label htmlFor="email-address" className="sr-only">Email address</label>
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  className="appearance-none rounded-none relative block w-full px-3 py-2 border-b-2 border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:z-10 sm:text-sm"
                  placeholder="Please enter your email ID"
                />
              </div>
            </div>
            <div>
              {loader ? (
                <Spinner size="80" />
              ) : (
                <button
                  type="submit"
                  className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                  Reset Password
                </button>
              )}
            </div>
          </form>
          <div className="text-center text-sm text-gray-600 mt-4">
            <Link to="/login" className="font-medium text-blue-600 hover:text-blue-500 flex items-center gap-x-3">
              <MdOutlineKeyboardBackspace /> Back to Sign in
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
